











import { Component, Vue, Prop } from 'vue-property-decorator'
import SlideBar from '@/apps/open/views/fileCenter/components/SlideBar.vue'

  @Component({
    components: {
      SlideBar
    }
  })
export default class FileMenu extends Vue {
  @Prop(Array)
  filemenu!: Array<object>

  filemenuslideshow = false

  fileMenuOpeneds = [ '/docs/cloud/join', '/docs/cloud/basic-ability', '/docs/cloud/cloud-ability', '/docs/cloud/enterprise-ability', '/docs/cloud/file-ability', '/docs/cloud/download-resource' ]

  onWindowClick (e: any) {
    if (e.target.className !== 'all-file-menu' && e.target.className !== 'el-icon-d-caret') {
      this.filemenuslideshow = false
    }
  }

  mounted () {
    let _this = this
    window.addEventListener('click', function (e) {
      _this.onWindowClick(e)
    }, true)
  }

  beforeDestroy () {
    let _this = this
    window.removeEventListener('click', function (e) {
      _this.onWindowClick(e)
    }, true)
  }

  onAllFileMenuClickStop () {
    this.filemenuslideshow = !this.filemenuslideshow
  }
}
